import { atom } from '@exodus/headless-ui';
const prefillIdAtom = atom(null);
export default prefillIdAtom;
